import { React, useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
// import ProgressBar from "react-bootstrap/ProgressBar";
// import { MaterialReactTable } from "material-react-table";
import { colors } from "@mui/material";


function RegionAnalysis() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [region, setRegion] = useState([]);
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const [monthlyOptions, setMonthlyOptions] = useState([]);
  const [weekColumns, setWeekColumns] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [bdOptions, setBdOptions] = useState([]);
  const [weekHeaders, setWeekHeaders] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();

  const { id } = useParams();
  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  
  const [selectedYear, setSelectedYear] = useState(currentFY);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_region_analysis/`,
        {
            params: { year: selectedYear, id: id },
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setRegion(response.data.region_name?.[0].name || []);
        setoptions(response.data.report_list || []);
        setMonthlyOptions(response.data.monthly_summary || []);
        setSectorOptions(response.data.sector_summary || []);
        setClientOptions(response.data.client_revenue || []);
        const target = response.data?.report_list?.[0]?.target || 0;
        const weeklyTarget = Math.round(target / 52);
        const weeklyData = response.data.weekly_summary || [];
        const weeks = [];
        for (let i = 1; i <= 53; i++) {
        const found = weeklyData.find(
            (x) => x.week_name === `W${i}`
        );
        const value = found ? Number(found.weekly_net_add) : 0;
        weeks.push({
            week_no: i,
            value,
            color: value < weeklyTarget ? "red" : "#16a34a",
        });
        }

        // Split into columns of 8
        const chunkSize = 8;
        const columns = [];
        for (let i = 0; i < weeks.length; i += chunkSize) {
        columns.push(
            weeks.slice(i, i + chunkSize)
        );
        }
        setWeekColumns(columns);

        const grouped = response.data.country_revenue.reduce((acc, item) => {
            if (!acc[item.country_name]) {
                acc[item.country_name] = [];
            }
            acc[item.country_name].push(item);
            return acc;
        }, {});

        // Sort countries by total revenue (highest first)
        const sortedGrouped = Object.fromEntries(
            Object.entries(grouped).sort(([, companiesA], [, companiesB]) => {
                const totalA = companiesA.reduce(
                    (sum, c) => sum + Number(c.revenue || 0),
                    0
                );

                const totalB = companiesB.reduce(
                    (sum, c) => sum + Number(c.revenue || 0),
                    0
                );

                return totalB - totalA; // Descending
            })
        );

        setCountryOptions(sortedGrouped);
        
        const bd_grouped = response.data.bd_revenue.reduce((acc, item) => {
            if (!acc[item.bd_by]) {
                acc[item.bd_by] = [];
            }
            acc[item.bd_by].push(item);
            return acc;
            }, {});
        setBdOptions(bd_grouped);
        
        const lastWeekNetAddColumns = response.data.weekly_sub_sector_revenue || [];
        const groupedData = {};
        const weekHeaders = [];
        /* Create headers + grouped structure */
        lastWeekNetAddColumns.forEach((item) => {

        /* Week Headers */
        if (
            !weekHeaders.find(
            (w) => w.week_no === item.week_no
            )
        ) {
            weekHeaders.push({
            week_no: item.week_no,
            week_label: item.week_label,
            });
        }

        /* Industry Grouping */
        if (!groupedData[item.industry]) {
            groupedData[item.industry] = {};
        }

        groupedData[item.industry][item.week_no] =
            item.revenue;
        });

        /* Sort latest week first */
        weekHeaders.sort((a, b) => b.week_no - a.week_no);	
        setWeekHeaders(weekHeaders);
        setGroupedData(groupedData);

        const d = response.data;
        
        const current_revenue = d?.report_list?.[0]?.total_amount || 0;
        const previous_revenue = d?.report_list?.[1]?.total_amount || 0;
        const average_vobt = d?.report_list?.[0]?.avg_vobt || 0;
        const average_vobt_last_year = d?.report_list?.[1]?.avg_vobt || 0;
        const arpa = d?.report_list?.[0]?.arpa || 0;
        const arpa_last_year = d?.report_list?.[1]?.arpa || 0;
        const average_fee = d?.report_list?.[0]?.avg_fee || 0;
        const avg_fee_vobt = d?.report_list?.[0]?.avg_fee_vobt || 0;
        const new_clients = d?.report_list?.[0]?.new_clients || 0;
        const existing_clients = d?.report_list?.[0]?.existing_clients || 0;
        const percentage = d?.report_list?.[0]?.percentage || 0;

        const current_net_add = d?.net_add_current_year?.[0]?.sum || 0;
        const prev_net_add = d?.net_add_prev_year?.[0]?.sum || 1;
        const revenue_growth = (((current_revenue - previous_revenue) / previous_revenue) * 100).toFixed(2);
        const net_add_growth = (((current_net_add - prev_net_add) / prev_net_add) * 100).toFixed(2);
        let total_roles = 0;
            for (const [key, value] of Object.entries(d?.total_searches[0])) {
                total_roles += parseInt(value);
            }
        if (response.status == 200) {
            setData({
            ...d,
            current_revenue,
            average_vobt,
            average_vobt_last_year,
            arpa,
            arpa_last_year,
            average_fee,
            avg_fee_vobt,
            new_clients,
            existing_clients,
            percentage,
            revenue_growth,
            current_net_add,
            net_add_growth,
            total_roles,
            weeklyTarget
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

useEffect(() => {
  if (token && selectedYear && id) {
    fetchOptions();
  }
}, [token, selectedYear, id]); 

  const financialYears = Array.from({ length: 4 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

    return (
        <>
        <style>
        {`
        .weekly-container{
        display:flex;
        gap:10px;
        flex-wrap:wrap;
        }

        .week-table{
        border-collapse:collapse;
        min-width:140px;
        }

        .week-table td{
        border:1px solid #dcdcdc;
        padding:4px 10px;
        font-size:14px;
        line-height:1.1;
        height:28px;
        }

        .week-table b{
        font-size:12px;
        }

        `}
        </style>
        <div className="card">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Region Analysis - {region}</h4>
                <div style={{ width: "150px" }}>
                    <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    >
                    {financialYears.map((fy) => (
                        <option key={fy.value} value={fy.value}>
                        {fy.label}
                        </option>
                    ))}
                    </select>
                </div>

                </div>

                <div className="row">
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-moneybag text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Revenue</p>
                                        <h5>₹ {formatNumber(data.current_revenue)}</h5>
                                    </div>
                                </div>
                                <div className="progress progress-xs mb-2">
                                    <div className="progress-bar bg-primary" role="progressbar" style={{ width: (data.percentage) }}></div>
                                </div>
                                <p className="fw-medium fs-13 mb-0">
                                <span className={`fs-12 ${
                                    data?.revenue_growth > 0
                                        ? "text-success"
                                        : "text-danger"
                                    }`}>
                                    <i className={`ti ${
                                        data?.revenue_growth > 0
                                        ? "ti-arrow-wave-right-up"
                                        : "ti-arrow-wave-right-down"
                                    } me-1`}></i>
                                        {data?.revenue_growth}% 
                                    </span> from last year</p>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-secondary flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-currency text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Net Add</p>
                                        <h5>₹ {formatNumber(data.current_net_add)}</h5>
                                    </div>
                                </div>
                                <div className="progress progress-xs mb-2">
                                    <div className="progress-bar bg-secondary" role="progressbar" style={{ width: "40%" }}></div>
                                </div>
                                <p className="fw-medium fs-13 mb-0">
                                    <span className={`fs-12 ${
                                    data?.net_add_growth > 0
                                        ? "text-success"
                                        : "text-danger"
                                    }`}>
                                        <i className={`ti ${
                                        data?.net_add_growth > 0
                                        ? "ti-arrow-wave-right-up"
                                        : "ti-arrow-wave-right-down"
                                    } me-1`}></i>{data?.net_add_growth}%  
                                    </span> from last year</p>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-info flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-files text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Total Searches</p>
                                        <h5>{data?.total_roles}</h5>
                                    </div>
                                </div>
                                <div className="row align-items-center fs-14 lh-1">
                                    <div className="col-md-6 col-sm-6">
                                        <div className="mb-1">
                                            <span className="text-success">
                                                Active: {data?.total_searches?.[0]?.active_roles}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-6">
                                        <div className="mb-1">
                                            <span className="text-info">
                                                Closed: {data?.total_searches?.[0]?.closed_roles}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-6">
                                        <div className="mb-1">
                                            <span className="text-primary">
                                                On Hold: {data?.total_searches?.[0]?.on_hold_roles}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-6">
                                        <div className="mb-1">
                                            <span className="text-secondary">
                                                Shelved: {data?.total_searches?.[0]?.on_shelved}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-warning flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-trending-up text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Growth</p>
                                    </div>
                                </div>
                                <p className="fw-medium fs-13 mb-0">
                                    <span className={`fs-16 ${
                                        data?.revenue_growth > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }`}>
                                        <i className={`ti ${
                                            data?.revenue_growth > 0
                                            ? "ti-arrow-wave-right-up"
                                            : "ti-arrow-wave-right-down"
                                        } me-1`}></i>
                                            {data?.revenue_growth}% 
                                        </span>  Revenue
                                        <br /><span className={`fs-16 ${
                                        data?.net_add_growth > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }`}>
                                        <i className={`ti ${
                                            data?.net_add_growth > 0
                                            ? "ti-arrow-wave-right-up"
                                            : "ti-arrow-wave-right-down"
                                        } me-1`}></i>
                                            {data?.net_add_growth}% 
                                        </span>  Net Add
                                </p>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-pink flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-lock-square-rounded text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Average VOBT</p>
                                        <h5>₹ {formatNumber(data.average_vobt)}</h5>
                                    </div>
                                </div>
                                <p className="fw-medium fs-13 mb-0"><span className="text-success fs-12">₹ {formatNumber(data.average_vobt_last_year)} </span> on last year</p>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-success flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-file-invoice text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">ARPA</p>
                                        <h5>₹ {formatNumber(data.arpa)}</h5>
                                    </div>
                                </div>
                                <p className="fw-medium fs-13 mb-0"><span className="text-success fs-12">₹ {formatNumber(data.arpa_last_year)} </span> on last year</p>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-danger flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-receipt text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Average Fee</p>
                                        <h5>{data.average_fee}</h5>
                                    </div>
                                </div>
                                <p className="fw-medium fs-13 mb-0"><span className="text-success fs-14 fs-bold">{data.avg_fee_vobt} </span> Average Fee on VOBT</p>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card position-relative">
                            <div className="card-body">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="avatar avatar-md br-10 icon-rotate bg-purple flex-shrink-0">
                                        <span className="d-flex align-items-center"><i className="ti ti-users-group text-white fs-16"></i></span>
                                    </div>
                                    <div className="ms-3">
                                        <p className="fw-medium text-truncate mb-1">Clients</p>
                                        <p className="fw-medium fs-13 mb-0"><span className="text-success fs-14 fs-bold">{data.new_clients} </span> New Clients</p>
                                        <p className="fw-medium fs-13 mb-0"><span className="text-info fs-14 fs-bold">{data.existing_clients} </span> Existing Clients</p>
                                    </div>
                                </div>
                                <span className="position-absolute top-0 end-0"><img src="../../assets/img/bg/card-bg-04.png" alt="Img" /></span>
                            </div>
                        </div>
                    </div>
                </div>  

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Year</th>
                                <th>Target</th>
                                <th>Achievement</th>
                                <th>%</th>
                                <th>Firmwide</th>
                                <th>Closed</th>
                                <th>Avg VOBT</th>
                                <th>Avg Fee</th>
                                <th>Avg Fee(VOBT)</th>
                                <th>ARPA</th>
                                <th>New Clients</th>
                                <th>Existing Clients</th>
                                <th>New Client Rev</th>
                                <th>Existing Client Rev</th>
                            </tr>
                            </thead>

                            <tbody>
                            {options.map((row, index) => (
                                <tr>
                                <td>{row.financial_year}</td>
                                <td>₹ {formatNumber(row.target)}</td>
                                <td>₹ {formatNumber(row.total_amount)}</td>
                                <td>{row.percentage}</td>
                                <td>{row.firmwide}</td>
                                <td>{row.searches_closed}</td>
                                <td>₹ {formatNumber(row.avg_vobt)}</td>
                                <td>{row.avg_fee}</td>
                                <td>{row.avg_fee_vobt}</td>
                                <td>₹ {formatNumber(row.arpa)}</td>
                                <td>{row.new_clients}</td>
                                <td>{row.existing_clients}</td>
                                <td>₹ {formatNumber(row.new_client_revenue)}</td>
                                <td>₹ {formatNumber(row.existing_client_revenue)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <div class="card-title mt-3">{region} Monthly Analysis</div>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th></th>
                                <th>Total</th>
                                <th>Q1</th>
                                <th>Q2</th>
                                <th>Q3</th>
                                <th>Q4</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>June</th>
                                <th>July</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                            </tr>
                            </thead>

                            <tbody>
                            {monthlyOptions.map((row, index) => (
                                <tr>
                                <td>{row.metric}</td>
                                <td>{formatNumber(row.Total)}</td>
                                <td>{formatNumber(row.Q1)}</td>
                                <td>{formatNumber(row.Q2)}</td>
                                <td>{formatNumber(row.Q3)}</td>
                                <td>{formatNumber(row.Q4)}</td>
                                <td>{formatNumber(row.Apr)}</td>
                                <td>{formatNumber(row.May)}</td>
                                <td>{formatNumber(row.Jun)}</td>
                                <td>{formatNumber(row.Jul)}</td>
                                <td>{formatNumber(row.Aug)}</td>
                                <td>{formatNumber(row.Sep)}</td>
                                <td>{formatNumber(row.Oct)}</td>
                                <td>{formatNumber(row.Nov)}</td>
                                <td>{formatNumber(row.Dec)}</td>
                                <td>{formatNumber(row.Jan)}</td>
                                <td>{formatNumber(row.Feb)}</td>
                                <td>{formatNumber(row.Mar)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <div class="card-title mt-3">{region} Weekly Analysis <span className="fs-14 text-muted">[Weekly Target: ({formatNumber(data.weeklyTarget)})]</span></div>
                            <div className="weekly-container">
                            {weekColumns.map((column, columnIndex) => (

                                <div className="week-column" key={columnIndex}>

                                <table className="week-table">
                                    <tbody>

                                    {column.map((week) => (

                                        <tr key={week.week_no}>

                                        <td>
                                            <b>W{week.week_no}</b>
                                        </td>

                                        <td style={{ color: week.color }}>
                                            {formatNumber(week.value)}
                                        </td>

                                        </tr>

                                    ))}

                                    </tbody>
                                </table>

                                </div>

                            ))}
                            </div>
                        </div>        
                    </div>
                </div> 

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "500px" }}>
                        <div class="card-title mt-3">{region} Revenue Sector Analysis</div>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                <th>Sector</th>
                                <th>Achievement</th>
                                <th>Closed</th>
                                <th>Active</th>
                                <th>New Clients</th>
                                <th>Existing Clients</th>
                                <th>Average VOBT</th>
                                <th>ARPA</th>
                                <th>Average Fee</th>
                                <th>Average Fee(VOBT)</th>
                            </tr>
                            </thead>

                            <tbody>
                            {sectorOptions.map((row, index) => (
                                <tr>
                                <td>{row.Sector}</td>
                                <td>{row.Achievement}</td>
                                <td>{row.Closed}</td>
                                <td>{row.Active}</td>
                                <td>{row.NewClients}</td>
                                <td>{row.ExistingClients}</td>
                                <td>{row.AverageVOBT}</td>
                                <td>{row.ARPA}</td>
                                <td>{row.AverageFee}</td>
                                <td>{row.AverageFeeVOBT}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-xxl-4 col-xl-4 d-flex">
                        <div className="card flex-fill">
                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                                Client Revenue
                            </h5>
                            </div>
                            <div className="card-body p-0">
                            <div
                                className="table-responsive"
                                style={{
                                maxHeight: "400px",
                                overflowY: "auto",
                                overflowX: "auto",
                                }}
                            >
                                <table	className="table table-bordered table-hover mb-0" style={{tableLayout: "fixed", width: "100%"	}}>
                                <thead
                                    className="table-dark"
                                    style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                    }}
                                >
                                    <tr>
                                    <th style={{ width: "70%" }}>Client</th>
                                    <th style={{ width: "30%" }}>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {clientOptions.map((row, index) => (
                                    <tr key={index}>
                                        <td	style={{wordBreak: "break-word",whiteSpace: "normal"}}>
                                        {row.client}
                                        </td>

                                        <td	style={{whiteSpace: "nowrap"}}>
                                        {row.amount}
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                            </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-xxl-4 col-xl-4 d-flex">
                        <div className="card flex-fill">

                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2">Country Revenue</h5>
                            </div>

                            <div className="card-body p-0">
                            <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto"}}>
                                <table	className="table table-bordered table-hover mb-0 align-middle"	style={{width: "100%", tableLayout: "fixed", fontSize: "13px"}}>
                                <thead	className="table-dark"	style={{position: "sticky",	top: 0,	zIndex: 1}}>
                                    <tr>
                                    <th	style={{width: "72%", wordBreak: "break-word", whiteSpace: "normal"}}>
                                        Country / Company
                                    </th>

                                    <th	st yle={{width: "28%",textAlign: "right",whiteSpace: "nowrap"}}>
                                        Amount
                                    </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.entries(countryOptions).map(
                                    ([country_name, companies]) => {
                                        const countryTotal = companies.reduce(
                                        (sum, c) => sum + Number(c.revenue),
                                        0
                                        );

                                    return (
                                        <>
                                            {/* Sector Row */}
                                            <tr className="table-secondary fw-bold">
                                            <td colSpan={2}	style={{padding: 0}}>
                                                <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    padding: "10px",
                                                    wordBreak: "break-word",
                                                    whiteSpace: "normal",
                                                    lineHeight: "18px",
                                                }}
                                                >
                                                <span>{country_name}</span>

                                                <span style={{ whiteSpace: "nowrap" }}>
                                                    {countryTotal.toLocaleString("en-IN")}
                                                </span>
                                                </div>
                                            </td>
                                            </tr>

                                            {/* Company Rows */}
                                            {companies.map((company, idx) => (
                                            <tr key={`${country_name}-${idx}`}>
                                                <td
                                                style={{
                                                    paddingLeft: "20px",
                                                    wordBreak: "break-word",
                                                    whiteSpace: "normal",
                                                    lineHeight: "18px",
                                                    width: "75%",
                                                }}
                                                >
                                                {company.company_name}
                                                </td>

                                                <td
                                                style={{
                                                    textAlign: "right",
                                                    whiteSpace: "nowrap",
                                                    width: "25%",
                                                }}
                                                >
                                                {Number(company.revenue).toLocaleString("en-IN")}
                                                </td>
                                            </tr>
                                            ))}
                                        </>
                                        );
                                    }
                                    )}
                                </tbody>
                                </table>
                            </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-xxl-4 col-xl-4 d-flex">
                        <div className="card flex-fill">
                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                                Business Developed
                            </h5>
                            </div>
                            <div className="card-body p-0">
                            <div
                                className="table-responsive"
                                style={{
                                maxHeight: "400px",
                                overflowY: "auto",
                                overflowX: "auto",
                                }}
                            >
                                <table	className="table table-bordered table-hover mb-0" style={{tableLayout: "fixed", width: "100%"	}}>
                                <thead
                                    className="table-dark"
                                    style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                    }}
                                >
                                    <tr>
                                    <th style={{ width: "70%" }}>BD By</th>
                                    <th style={{ width: "30%" }}>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.entries(bdOptions).map(([bd, companies]) => {
                                        const total = companies.reduce(
                                        (sum, c) => sum + Number(c.revenue),
                                        0
                                        );

                                        return [
                                        /* BD Header */
                                        <tr key={`${bd}-header`} className="table-secondary fw-bold">
                                            <td>{bd}</td>

                                            <td
                                            style={{
                                                textAlign: "right",
                                                whiteSpace: "nowrap",
                                            }}
                                            >
                                            {total.toLocaleString("en-IN")}
                                            </td>
                                        </tr>,

                                        /* Company Rows */
                                        ...companies.map((company, idx) => (
                                            <tr key={`${bd}-${idx}`}>
                                            <td
                                                style={{
                                                paddingLeft: "20px",
                                                wordBreak: "break-word",
                                                whiteSpace: "normal",
                                                }}
                                            >
                                                {company.company_name}
                                            </td>

                                            <td
                                                style={{
                                                textAlign: "right",
                                                whiteSpace: "nowrap",
                                                }}
                                            >
                                                {Number(company.revenue).toLocaleString("en-IN")}
                                            </td>
                                            </tr>
                                        )),
                                        ];
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default RegionAnalysis;